import { ref } from 'vue'
import { defineStore } from 'pinia'
import type DMGetDataResponse from '#src/interfaces/DMGetDataResponse'

export const useDeviceManagementStore = defineStore('deviceManagementStore', () => {
  const isDmReady = ref<boolean>(false)
  const appData = ref<DMGetDataResponse | undefined>()

  return { isDmReady, appData }
})
